import { reactive } from "vue";

let instance = null;

/**
 * Shared view-state for OperatingCountryTable filters / search UI.
 * Mirrors useOperatingCurrenciesTableViewState — status filter only (no rate mode).
 */
export function useOperatingCountryTableViewState() {
  if (instance) return instance;

  const state = reactive({
    filters: {
      values: ["active"],
      searchText: "",
      searchGhostText: "Search country",
      showFilterDialog: false,
      key: "operatingCountryTable",
      statusOptions: ["active", "retired"],
    },
  });

  instance = { state };
  return instance;
}

export function resetOperatingCountryTableViewState() {
  instance = null;
}
